<form class="form-inline">
    <div class="form-group">
      <div class="input-group">
        <input class="form-control" placeholder="yyyy-mm-dd"
               name="dp" [(ngModel)]="model" ngbDatepicker #d="ngbDatepicker" (dateSelect)="onDateSelection($event)" readonly 
               [maxDate]="{year: max_date.year, month: max_date.month, day: max_date.day }">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" type="button"><i class="fas fa-calendar-week"></i></button>
        </div>
      </div>
    </div>
  </form>
  
